import * as Safe from "safe-portals";
import { Serializers } from "@flow/common/types";

export type SignatureGuid = string;

export const petitionPersonalDataSerializer = Safe.obj({
  name: Safe.str,
  email: Safe.str,
  postcode: Safe.str,
  metadata: Safe.optional(
    Safe.obj({
      userAgent: Safe.str,
      ipAddress: Safe.str,
    })
  ),
  comment: Safe.optional(Safe.str),
});

export const petitionSignatureSerializer = Safe.obj({
  guid: Safe.str,
  action_guid: Safe.str,
  signed_at: Safe.dateIso,
  personal_data: Safe.optional(petitionPersonalDataSerializer),
  consents: Safe.array(Serializers.consent),
  owner: Safe.optional(Serializers.personalDataOwner),
});
export type PetitionSignature = Safe.TypeIn<typeof petitionSignatureSerializer>;

/**
 * Signature listings (ViewPetitionSignatures) consist of the usual Signature type,
 * plus some additional fields to show the journey they were submitted on.
 */
export const signatureListedSerializer = Safe.obj({
  guid: Safe.str,
  action_guid: Safe.optional(Safe.str),
  signed_at: Safe.dateIso,
  owner: Safe.optional(Safe.array(Safe.str)),
  personal_data: Safe.optional(petitionPersonalDataSerializer),
  consents: Safe.array(Serializers.consent),
  action_title: Safe.optional(Safe.str),
  journey_name: Safe.optional(Safe.str),
  journey_guid: Safe.optional(Safe.str),
  comment: Safe.optional(Safe.str),
});
export type SignatureListed = Safe.TypeIn<typeof signatureListedSerializer>;

/**
 * Signature Exported consist of the usual Signature type,
 * with
 */
export const signatureHandInExportSerializer = Safe.obj({
  signed_at: Safe.dateIso,
  name: Safe.str,
  email: Safe.str,
  postcode: Safe.str,
});
export type SignatureHandInExport = Safe.TypeIn<typeof signatureHandInExportSerializer>;

/**
 * Signature Exported consist of the usual Signature type,
 * with
 */
export const signatureInternalExportSerializer = Safe.obj({
  guid: Safe.uuid,
  signed_at: Safe.dateIso,
  personal_data: petitionPersonalDataSerializer,
});
export type SignatureInternalExport = Safe.TypeIn<typeof signatureInternalExportSerializer>;

/**
 * Signature listings (ViewPetitionSignatures) consist of the usual Signature type,
 * plus some additional fields to show the journey they were submitted on.
 */
export const petitionListedSerializer = Safe.obj({
  guid: Safe.str,
  action_title: Safe.optional(Safe.str),
  created_at: Safe.dateIso,
});
export type PetitionListed = Safe.TypeIn<typeof petitionListedSerializer>;

/**
 * Recent Signatures are a stripped down Signature type,
 * It's using to display things publically, don't want to leak everything
 */
export const recentSignatureListedSerializer = Safe.obj({
  guid: Safe.str,
  signed_at: Safe.dateIso,
  name: Safe.str,
});
export type RecentSignatureListed = Safe.TypeIn<typeof recentSignatureListedSerializer>;

/**
 * Some useful stats for investigating duplicate signatures
 */
export const duplicateSignatureItemSerializer = Safe.obj({
  email: Safe.str,
  signs: Safe.int,
  distinct_ip: Safe.int,
  distinct_ua: Safe.int,
  first_sign: Safe.dateIso,
  last_sign: Safe.dateIso,
});
export type DuplicateSignatureItem = Safe.TypeIn<typeof duplicateSignatureItemSerializer>;

export const decisionNotificationEmailParamsSerializer = Safe.obj({
  petition_title: Safe.str,
  email_body: Safe.str,
  subject_line: Safe.str,
  decision_maker_email: Safe.str,
  decision_maker_name: Safe.str,
  signatures: Safe.str,
  from_name: Safe.str,
  from_email: Safe.str,
  petition_url: Safe.str,
});
export type DecisionNotificationEmailParams = Safe.TypeIn<typeof decisionNotificationEmailParamsSerializer>;
